export const AUTH_USER_TOKEN_KEY = "authToken";
export const AUTH_USER_TOKEN_KEY_LEGACY = "ReactAmplify.TokenKey";
export const AUTH_ACCESS_TOKEN_KEY = "accessToken";
export const AUTH_REFRESH_TOKEN_KEY = "AUTH_REFRESH_TOKEN";
export const OPEN_GLOBAL_REMINDER_EVENT = "cs:open-global-reminder";
// Fired from the AppBar (standalone Journal route) to trigger a JournalPanel
// toolbar action on the global/standalone journal. detail = { action, anchorEl }.
export const JOURNAL_ACTION_EVENT = "cs:journal-action";
// Fired when a reminder row asks to open its linked entity's journal while
// the target page is already mounted. detail = { collection, id }.
export const SELECT_ENTITY_JOURNAL_EVENT = "cs:select-entity-journal";
